import React, { useState } from "react";
import SiteChrome from "@/components/SiteChrome";
import { API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { usePlatformMessages } from "@/lib/usePlatformMessages";

export default function DiplomaMassa() {
  const { t } = useI18n();
  const { m } = usePlatformMessages();
  const [email, setEmail] = useState("");
  const [format, setFormat] = useState("zip");
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/diplomas/bulk/download`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, format }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Erro");
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = format === "zip" ? "diplomas.zip" : "diplomas.pdf";
      a.click();
      URL.revokeObjectURL(url);
      toast.success(m("diplomas_mass_downloaded", null, "Diplomas descarregados!"));
    } catch (e) {
      toast.error(e.message || m("diploma_download_error", null, "Erro"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteChrome>
    <div className="min-h-screen bg-slate-50 font-[Nunito]">
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="text-3xl font-[Fredoka] font-semibold text-slate-900 mb-2">{t("diploma_bulk")}</h1>
        <div className="bg-white border border-slate-200 rounded-3xl p-8 space-y-4 shadow-sm mt-6">
          <div>
            <Label>{t("email")} (do professor)</Label>
            <Input data-testid="dipm-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label>Formato</Label>
            <Select value={format} onValueChange={setFormat}>
              <SelectTrigger data-testid="dipm-format"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="zip" data-testid="dipm-format-zip">ZIP — 1 PDF por aluno</SelectItem>
                <SelectItem value="pdf" data-testid="dipm-format-pdf">PDF único multi-página</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button data-testid="btn-dipm-download" disabled={loading || !email} onClick={download} className="w-full bg-pink-500 hover:bg-pink-600 rounded-full font-bold">
            {t("download_diploma")}
          </Button>
        </div>
      </div>
    </div>

    </SiteChrome>
  );
}
